<template>
  <div class="card-watched">
    <div class="box" @click="toggleVisibility('Watchlist')">
      <span class="box-quantity"> {{ items_user.watchlist }} </span>
      <span class="box--title">WATCHLIST</span>
      <span class="box--icon"><font-awesome-icon icon="check"/></span>
    </div>
    <div class="box" @click="toggleVisibility('Watched')">
      <span class="box-quantity"> {{ items_user.watched }} </span>
      <span class="box--title">WATCHED</span>
      <span class="box--icon"><font-awesome-icon icon="eye"/></span>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  computed: mapState(["items_user"]),
  methods: {
    toggleVisibility(params) {
      this.$store.commit("EDIT_ITEMS_VISIBILITY_WATCHED_SHOWS", params);
      this.$router.push("watchlist");
    }
  }
};
</script>

<style scoped>
.card-watched {
  display: flex;
  column-gap: 20px;
  justify-content: center;
}

.box {
  height: 70px;
  width: 100px;
  padding: 2.5px;
  border-radius: 15px;
  background-color: rgba(0, 0, 0, 0.25);
  color: white;
  text-align: center;
  display: flex;
  flex-direction: column;
  cursor: pointer;
  margin-right: 10px;
}

.box-quantity {
  font-size: 1.7em;
}
.box--title {
  text-transform: uppercase;
  font-size: 0.7em;
}
.box--icon {
  color: #94c659;
}
</style>
